module.exports = __webpack_public_path__ + "861bebe2f556e36b323d57fd7b4eebff.svg";